import React from 'react'
import SecondHeader from '../../components/SecondHeader/SecondHeader'
import SuperAdminSidebar from '../../components/superadminsidebar/SuperAdminSidebar'

const AdminDashboardLayout = ({ children }) => {
    return (
        <>
            <SecondHeader />
            <div className="container-fluid">
                <div className="row">
                    <div className="ps-0 col-md-2">
                        <SuperAdminSidebar />
                    </div>

                    <div className="col-md-10">
                        {children}
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdminDashboardLayout